module.exports = __webpack_public_path__ + "static/forecast/temperature/thaw-6733e273ec45756488d6516f50cae1b5.svg";